<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col cols="12">
                <responsiveButton :setText="true"
                                  setColor="orange"
                                  setDefaultIcon="mdi-refresh"
                                  setSmallIcon="mdi-refresh"
                                  :setClick="loadData"
                >
                    Refresh Data
                </responsiveButton>
                <responsiveButton :setTo="`/orgWorkSpace/employee/details/${id}/clients/assigment`"
                                  setColor="blue"
                                  setDefaultIcon="mdi-plus"
                                  setSmallIcon="mdi-plus-circle-outline"
                                  style="float: right"
                >
                    Clients
                </responsiveButton>
                <v-divider class="mx-6; mt-1"></v-divider>
                <v-data-table
                        :headers="clientsTable.headers"
                        :items="clients"
                        class="elevation-1"
                        :loading="loading"
                        loading-text="Loading... Please wait"
                >
                    <template v-slot:item.emailVerified="{item}">
                        <v-chip :color="getColorForEmail(item.emailVerified)" dark>
                            {{item.emailVerified?'': 'Not '}} Verified
                        </v-chip>
                    </template>
                    <!--actions-->
                    <template v-slot:item.view="{item}">
                        <v-icon
                                class="mr-2"
                                @click="viewClientDetails(item)"
                        >
                            {{ CLIENT_ACTIONS.VIEW.icon }}
                        </v-icon>
                    </template>
                    <template v-slot:item.remove="{item}">
                        <v-icon
                                class="mx-auto"
                                @click="confirmDelete(item)"
                        >
                            {{ CLIENT_ACTIONS.DELETE.icon }}
                        </v-icon>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <dialog-alert
                :text="confirmAlertText"
                :alert-type="confirmAlertType"
                :open="openConfirmation"
                @alert-closed="dialogClosed($event)"
        ></dialog-alert>
    </v-container>
</template>

<script>
    import alertEventBus from '@/eventBus/AlertEventBus';
    const responsiveButton = ()=> import( '@/components/common/mobile/Button');
    const DialogAlert = () => import("@/components/common/DialogAlert");
    import { ALERT_TYPES, CONFIRM_UNASSIGMENT } from "@/shared/enums/AlertTexts";
    import {CLIENT_ACTIONS} from "@/shared/enums/Client";

    export default {
        name: "employeeTable",
        components: { responsiveButton, DialogAlert },
        props:["id", "type"],
        data(){
            return {
                clients: [],
                employee: null,
                loading: true,
                clientsTable: {
                    headers: [
                        {
                            text: 'Name',
                            align: 'center',
                            sortable: true,
                            value: 'name',
                        },
                        {
                            text: 'Address',
                            align: 'center',
                            sortable: true,
                            value: 'address'
                        },
                        {
                            text: 'Client Type',
                            align: 'center',
                            sortable: true,
                            divider: true,
                            value: 'typeName'
                        },
                        // {
                        //     text: 'Hours work',
                        //     align: 'center',
                        //     sortable: true,
                        //     divider: true,
                        //     value: 'emailVerified'
                        // },
                        {
                            text: 'View',
                            align: 'center',
                            width: '2%',
                            value: 'view',
                            sortable: false
                        },
                        {
                            text: 'Remove',
                            align: 'center',
                            width: '2%',
                            value: 'remove',
                            sortable: false
                        }
                    ]
                },
                confirmAlertType: ALERT_TYPES.CONFIRM,
                confirmAlertText: CONFIRM_UNASSIGMENT,
                openConfirmation: false,
                itemtoUnAssigment: null
            };
        },
        computed:{
            CLIENT_ACTIONS(){
                return CLIENT_ACTIONS;
            }
        },
        methods:{
            async loadData(){
                try {
                    //call store type
                    let getForType = 'getEmployee';
                    await this.$store.dispatch(getForType, {id: this.id});
                    let user = this.$store.getters[getForType];

                    if(!!!user){
                        throw {message: `Not valid ${this.path_type} found for id: ${this.path_id}`};
                    }
                    this.clients = [];
                    this.employee = {...user};
                    this.$log.debug(this.employee)
                    Object.keys(this.employee.clients).forEach(elem => {
                        let data = this.employee.clients[elem];

                        this.clients.push({
                            id: elem,
                            name: data.name,
                            address: data.address,
                            typeName: data.typeName
                        });
                    })
                    this.loading = false;
                }
                catch (e) {
                    //set alert
                    this.$log.debug(e);
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    return;
                }
            },
            async deleteAssignment(user) {
                try {
                    //remove
                    delete this.employee.clients[user.id]
                    await this.$store.dispatch('setEmployee', this.employee);

                    await this.$store.dispatch('getClient', {id: user.id});
                    let client = this.$store.getters.getClient;
                    //remove
                    delete client.employees[this.employee.id];
                    await this.$store.dispatch('setClient', client);
                }
                catch (e) {
                    alertEventBus.setAlert({ type: "error", msg: e.message });
                    return;
                }
                this.itemtoUnAssigment = null;
                this.loadData();
            },
            viewClientDetails(client){
                this.$router.push({name: CLIENT_ACTIONS.VIEW.route, params:{id:client.id}});
            },
            confirmDelete(item) {
                this.openConfirmation = true;
                this.itemtoUnAssigment = item;
            },
            dialogClosed(answer) {
                this.openConfirmation = false;
                if (answer) {
                    this.deleteAssignment(this.itemtoUnAssigment);
                }
            }
        },
        async created(){
            await this.loadData();
        }
    }
</script>

<style>
    .v-chip.white-span span {
        color: white !important;
    }
</style>